import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import fetchTrace from "../services/fetchTrace";
import patchData from "../services/patchData";
import postData from "../services/postData";
import putData from "../services/putData";

const handleFetchUsers = async () => {
  const uri = `v1/users`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateUser = async (data: any) => {
  const uri = `v1/users`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateUser = async ({ data, _id }: any) => {
  const uri = `v1/users/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleCountUsers = async ({ data, _id }: any) => {
  const uri = `v1/users/count/all`;
  const response = putData({ data, uri });
  return response;
};

const handleFetchAdvisors= async () => {
  const uri = `v1/users/advisors/all`;
  const response = fetchData({  uri });
  return response;
};


const handleFetchVMSUsers = async () => {
  const uri = `users`;
  const response = fetchTrace({ uri });
  return response;
};


const handleExportUsers = async ({ data, _id }: any) => {
  const uri = `v1/users/export/all`;
  const response = putData({ data, uri });
  return response;
};

const handleDeleteUser = async ({ _id }: any) => {
  const uri = `v1/users/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchUsers,
  handleCreateUser,
  handleUpdateUser,
  handleDeleteUser,
  handleCountUsers,
  handleExportUsers,
  handleFetchAdvisors,
  handleFetchVMSUsers
};
